import { render, staticRenderFns } from "./PublicDashboardCreate.vue?vue&type=template&id=0197f9f5"
import script from "./PublicDashboardCreate.vue?vue&type=script&lang=js"
export * from "./PublicDashboardCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports